import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TaskIconPickerComponent} from 'src/app/shared/tasks/icon-picker/task-icon-picker.component';
import {OphButtonModule} from 'src/app/shared/design/oph-button/oph-button.module';
import {OphXButtonComponent} from './../../../../shared/design/oph-x-button/oph-x-button.component';

interface DialogData {
  currentIcon?: string;
}

@Component({
  selector: 'cb-task-icon-picker-dialog',
  standalone: true,
  imports: [TaskIconPickerComponent, OphButtonModule, OphXButtonComponent],
  templateUrl: './cb-task-icon-picker-dialog.component.html',
  styleUrl: './cb-task-icon-picker-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbTaskIconPickerDialogComponent {
  readonly dialogRef = inject(MatDialogRef<CbTaskIconPickerDialogComponent>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA, {optional: true});

  onIconChange(iconName: string): void {
    if (iconName) {
      setTimeout(() => this.dialogRef.close(iconName), 300);
    }
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }
}
